import React from 'react';

const Skills = ({ children }) => {

    return (
        <div className='row'>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">html</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="80" style={{ 'width': '80%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(20% - 21px)' }}>80%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">css</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="70" style={{ 'width': '70%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(30% - 21px)' }}>70%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">bootstrap</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="80" style={{ 'width': '80%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(20% - 21px)' }}>80%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">react bootstrap</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="65" style={{ 'width': '65%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(35% - 21px)' }}>65%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">tailwind css</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="50" style={{ 'width': '50%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(50% - 21px)' }}>50%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">mui</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="55" style={{ 'width': '55%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(45% - 21px)' }}>55%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">javascript</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="65" style={{ 'width': '65%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(35% - 21px)' }}>65%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">react</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="80" style={{ 'width': '80%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(20% - 21px)' }}>80%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">redux</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="30" style={{ 'width': '30%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(70% - 21px)' }}>30%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">firebase</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="60" style={{ 'width': '60%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(40% - 21px)' }}>60%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">mongodb</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="50" style={{ 'width': '50%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(50% - 21px)' }}>50%
                        {children}
                    </span>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4">
                <span class="skill-text">mysql</span>
                <div className='chart-bar'>
                    <span className='item-progress' data-percent="35" style={{ 'width': '35%' }}></span>
                    <span class="percent" style={{ 'right': 'calc(65% - 21px)' }}>35%
                        {children}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Skills;